module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Homie for ESP8266")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Set up your device.")]), _vm._v(" "), _c('progress-bar', {
    attrs: {
      "current-step": _vm.currentStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.currentStep === 1) ? _c('connection-step', {
    on: {
      "done": _vm.goToNextStep,
      "loading": _vm.setLoading,
      "loaded": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 2) ? _c('info-step', {
    on: {
      "deviceInformation": _vm.receiveDeviceInformation,
      "done": _vm.goToNextStep,
      "loading": _vm.setLoading,
      "loaded": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 3) ? _c('wifi-step', {
    on: {
      "wifiConfig": _vm.receiveWifiConfig,
      "done": _vm.goToNextStep,
      "loading": _vm.setLoading,
      "loaded": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 4) ? _c('mqtt-step', {
    on: {
      "mqttConfig": _vm.receiveMqttConfig,
      "done": _vm.goToNextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 5) ? _c('settings-step', {
    attrs: {
      "device-information": _vm.deviceInformation
    },
    on: {
      "settingsConfig": _vm.receiveSettingsConfig,
      "done": _vm.goToNextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 6) ? _c('sending-step', {
    attrs: {
      "configuration": _vm.config
    },
    on: {
      "loading": _vm.setLoading,
      "loaded": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "notification"
  }, [_c('span', {
    staticClass: "button is-loading"
  }, [_vm._v("Loading")]), _vm._v(" " + _vm._s(_vm.loadingText) + "\n    ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f99b72e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 59
// module chunks = 0